/* eslint-disable react-native/no-unused-styles */
import React from 'react';
import { StyleSheet, Platform } from 'react-native';
import HTMLView from 'react-native-htmlview';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import Colors from 'src/core/utils/Colors';
import linkifyHtml from 'src/core/utils/linkifyHtml';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import type { ApiContentBlockText } from 'src/core/models/api/ApiContentBlock';

interface ContentBlockTextProps {
	data: ApiContentBlockText;
}

export default function ContentBlockText({ data }: ContentBlockTextProps) {
	const { openUrlInternally } = useServicesStore();

	// Emails/phone numbers in plain text are made tappable; links route through the in-app browser (which
	// delegates tel:/mailto: to the OS mail/dialer client).
	return (
		<HTMLView
			style={styles.text}
			stylesheet={styles}
			value={'<p>' + linkifyHtml(data.data.cb_text) + '</p>'}
			onLinkPress={(url: string) => {
				openUrlInternally({ url }).catch(() => undefined);
			}}
		/>
	);
}

const styles = StyleSheet.create({
	text: {
		// No flex:1 here: inside the page's flexGrow ScrollView it would stretch the text block and push following
		// blocks (e.g.
		paddingLeft: Platform.OS === 'ios' ? Dimens.padding20 : Dimens.padding16,
		paddingRight: Platform.OS === 'ios' ? Dimens.padding20 : Dimens.padding16,
		paddingTop: Platform.OS === 'ios' ? Dimens.padding5 : Dimens.padding5,
		paddingBottom: Platform.OS === 'ios' ? Dimens.padding15 : Dimens.padding8,
	},
	p: {
		fontFamily: Fonts.montserratRegular,
		fontSize: Dimens.fontSize17,
		color: Colors.greyTextDark,
		lineHeight: Dimens.lineHeight23,
	},
	a: {
		fontFamily: Fonts.montserratMedium,
		fontSize: Dimens.fontSize17,
		color: Colors.secondary,
		lineHeight: Dimens.lineHeight23,
	},
	b: {
		fontFamily: Fonts.montserratBold,
	},
	// The editor writes bold as <strong>. A custom font needs the bold face by name: fontWeight alone, which is
	// all the library gives <strong>, leaves Montserrat-Regular regular (#430).
	strong: {
		fontFamily: Fonts.montserratBold,
	},
});
